/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MarketRegisterScannerIcon16Solid = forwardRef('MarketRegisterScannerIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 1a3 3 0 0 0 0 6h7.239a1.75 1.75 0 0 0 1.66-1.197l.943-2.829A1.5 1.5 0 0 0 13.419 1H5Z" }),
        React.createElement("path", { d: "m3.944 8-1.416 5.098A1.5 1.5 0 0 0 3.974 15H5.11a1.5 1.5 0 0 0 1.445-1.098L8.195 8h-4.25Z" }),
        React.createElement("path", { d: "m8.117 11 .863-3h2.107l-.608 1.947A1.5 1.5 0 0 1 9.047 11h-.93Z" })));
});
